var chunkMapping = {
	"0": [
		4900
	],
	"149": [
		5089
	],
	"150": [
		5090
	],
	"153": [
		5093
	],
	"154": [
		5094
	],
	"155": [
		5095
	],
	"156": [
		5096
	],
	"157": [
		5097
	],
	"158": [
		5098
	],
	"159": [
		5099
	],
	"160": [
		5100
	],
	"161": [
		5101
	],
	"162": [
		5102
	],
	"163": [
		5103
	],
	"164": [
		5104
	],
	"165": [
		5105
	],
	"166": [
		5106
	],
	"167": [
		5107
	],
	"168": [
		5108
	],
	"169": [
		5109
	]
};
var idToExternalAndNameMapping = {
	"4900": [
		"default",
		"./Containers",
		3797
	],
	"5089": [
		"default",
		"./AsyncEventTracker",
		3797
	],
	"5090": [
		"default",
		"./HostWrapper",
		3797
	],
	"5093": [
		"default",
		"./CheckoutV3",
		3797
	],
	"5094": [
		"default",
		"./CheckoutConfirmation",
		3797
	],
	"5095": [
		"default",
		"./ContactCreditCards",
		3797
	],
	"5096": [
		"default",
		"./AuditDialog",
		3797
	],
	"5097": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3797
	],
	"5098": [
		"default",
		"./InvoiceDialog",
		3797
	],
	"5099": [
		"default",
		"./PaymentDueModal",
		3797
	],
	"5100": [
		"default",
		"./PaymentModal",
		3797
	],
	"5101": [
		"default",
		"./PaymentHistory",
		3797
	],
	"5102": [
		"default",
		"./PaymentConfigurations",
		3797
	],
	"5103": [
		"default",
		"./PaymentPreferences",
		3797
	],
	"5104": [
		"default",
		"./ManagePaymentProcessing",
		3797
	],
	"5105": [
		"default",
		"./MobilePaymentsWrapper",
		3797
	],
	"5106": [
		"default",
		"./Challenge",
		3797
	],
	"5107": [
		"default",
		"./ManagePaymentMethods",
		3797
	],
	"5108": [
		"default",
		"./LightspeedReports",
		3797
	],
	"5109": [
		"default",
		"./ShippingPromotionsListContainer",
		3797
	]
};
var idToRemoteMap = {
	"4900": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5089": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5090": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5093": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5094": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5095": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5096": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5097": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5098": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5099": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5100": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5101": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5102": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5103": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5104": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5105": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5106": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5107": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5108": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	],
	"5109": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3797
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}